export default __webpack_public_path__ + "static/media/happy.8cfa06f6.svg";